import React from 'react';
import { StickyHeader } from './components/StickyHeader';
import { MobileBottomBar } from './components/MobileBottomBar';
import { HeroSection } from './components/HeroSection';
import { PriceMoatBlock } from './components/PriceMoatBlock';
import { ThreeDayGuarantee } from './components/ThreeDayGuarantee';
import { TourBookingPanel } from './components/TourBookingPanel';
import { WhyFuntastic } from './components/WhyFuntastic';
import { ProgramsSection } from './components/ProgramsSection';
import { Gallery } from './components/Gallery';
import { TrustHub } from './components/TrustHub';
import { CCSCalculator } from './components/CCSCalculator';
import { DayTimeline } from './components/DayTimeline';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SchemaMarkup } from './components/SchemaMarkup';
export function App() {
  return <div className="min-h-screen bg-cream font-body text-navy selection:bg-yellow/30 selection:text-navy overflow-x-hidden" data-id="element-0">
      <SchemaMarkup data-id="element-1" />
      <StickyHeader data-id="element-2" />

      <main className="pt-20" data-id="element-3">
        <HeroSection data-id="element-4" />
        <PriceMoatBlock data-id="element-5" />
        <ThreeDayGuarantee data-id="element-6" />
        <TourBookingPanel data-id="element-7" />
        <WhyFuntastic data-id="element-8" />
        <ProgramsSection data-id="element-9" />
        <Gallery data-id="element-10" />
        <TrustHub data-id="element-11" />
        <CCSCalculator data-id="element-12" />
        <DayTimeline data-id="element-13" />
        <FAQSection data-id="element-14" />
        <FinalCTA data-id="element-15" />
      </main>

      <Footer data-id="element-16" />
      <MobileBottomBar data-id="element-17" />

      {/* REQUIRED OUTPUTS (Hidden from UI, visible in code for developer) */}
      <div className="hidden" aria-hidden="true" data-id="element-18">
        <h2 data-id="element-19">1. Pre-Launch Checklist</h2>
        <ul data-id="element-20">
          <li data-id="element-21">Hero: $118/day rate and $24 CCS rate</li>
          <li data-id="element-22">Hero: 4.0/81 CareforKids reviews permission</li>
          <li data-id="element-23">Hero: 4.0/25 Google reviews permission</li>
          <li data-id="element-24">Hero: Year established ("Family-run since [year]")</li>
          <li data-id="element-25">Price Moat: Competitor rates at publish time</li>
          <li data-id="element-26">3 Day Guarantee: Current subsidy bands at publish</li>
          <li data-id="element-27">Why Funtastic: Sanjay Sharma as Director name</li>
          <li data-id="element-28">Why Funtastic: Last NQS visit date (September 2025)</li>
          <li data-id="element-29">Why Funtastic: Dietary/cultural meals policy</li>
          <li data-id="element-30">Programs: 1:4 ratio claim in Nursery</li>
          <li data-id="element-31">Programs: Government-approved Pre-Kinder/Kinder wording</li>
          <li data-id="element-32">Trust Hub: Real review quotes needed</li>
          <li data-id="element-33">Trust Hub: ACECQA service registration number</li>
          <li data-id="element-34">Trust Hub: Safety checks (WWCC, Police, CCTV, First Aid)</li>
          <li data-id="element-35">Programs: Exact name of the parent app (e.g., OWNA)</li>
          <li data-id="element-36">
            Why Funtastic: Sanjay's name, founding year, one-line story, current
            enrolment number
          </li>
          <li data-id="element-37">Schema: Exact latitude and longitude</li>
          <li data-id="element-38">Mobile Bar: Verify WhatsApp Business number is active</li>
        </ul>
      </div>
    </div>;
}